import React, { FC } from 'react';
import clsx from 'clsx';
import { PreorderIconProps } from '../types';
import styles from './PreorderIcon.scss';

export const PreorderIcon: FC<PreorderIconProps> = ({
  className
}) => {
  const rootClassNames = clsx([styles.root, className]);

  return (
    <svg
      className={rootClassNames}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5922 4.34194C18.006 4.15269 18.4817 4.15269 18.8955 4.34194L21.3626 5.47031L11.5399 10.2331L8.12565 8.67159L17.5922 4.34194ZM14.1347 11.4199L18.2438 13.2993L28.362 8.67159L23.9574 6.65709L14.1347 11.4199ZM19.8105 2.34126C18.8156 1.88625 17.6721 1.88625 16.6772 2.34126L5.97454 7.23625C5.41289 7.49312 5.05267 8.05399 5.05267 8.67159C5.05267 8.70304 5.0536 8.73433 5.05545 8.76545C5.05354 8.79193 5.05257 8.81867 5.05257 8.84564V16.4546C5.05257 17.0622 5.54506 17.5546 6.15257 17.5546C6.76009 17.5546 7.25257 17.0622 7.25257 16.4546V10.6915L17.7802 15.5064V27.0182L16.8449 26.5285C16.3067 26.2467 15.642 26.4546 15.3602 26.9928C15.0784 27.531 15.2863 28.1957 15.8245 28.4775L17.0241 29.1056C18.1171 29.6778 19.421 29.6786 20.5146 29.1076L29.4117 24.4622C30.6553 23.8129 31.435 22.5262 31.435 21.1233V9.32025C31.435 9.26204 31.4305 9.20489 31.4218 9.14913C31.4305 9.09334 31.435 9.03644 31.435 8.97882V8.36437C31.435 7.93394 31.184 7.54305 30.7925 7.36403L19.8105 2.34126ZM28.3935 22.5121L19.9802 26.9048V14.9243L29.235 10.6915V21.1233C29.235 21.7068 28.9107 22.242 28.3935 22.5121ZM2.33438 22.489C1.72686 22.489 1.23438 22.9815 1.23438 23.589C1.23438 24.1966 1.72686 24.689 2.33437 24.689H10.1406C10.7481 24.689 11.2406 24.1966 11.2406 23.589C11.2406 22.9815 10.7481 22.489 10.1406 22.489L2.33438 22.489ZM6.32544 27.4806C6.32544 26.8731 6.81793 26.3806 7.42544 26.3806H12.5177C13.1252 26.3806 13.6177 26.8731 13.6177 27.4806C13.6177 28.0881 13.1252 28.5806 12.5177 28.5806H7.42544C6.81793 28.5806 6.32544 28.0881 6.32544 27.4806ZM6.15257 18.5975C5.54506 18.5975 5.05257 19.09 5.05257 19.6975C5.05257 20.305 5.54506 20.7975 6.15257 20.7975H8.84014C9.44765 20.7975 9.94014 20.305 9.94014 19.6975C9.94014 19.09 9.44765 18.5975 8.84014 18.5975H6.15257Z"
        fill="currentColor"
      />
    </svg>
  );
};
